import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-6 md:py-8 border-t border-white/5 bg-deep-black" data-id="element-50">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-51">
          <p className="text-white/30 text-xs font-light" data-id="element-52">
            © {new Date().getFullYear()} L'Algorithme de l'Amour. Tous droits
            réservés.
          </p>
          <div className="flex items-center gap-6" data-id="element-53">
            <button onClick={() => setActiveModal('privacy')} className="text-white/40 hover:text-champagne-gold text-xs font-light tracking-wide transition-colors cursor-pointer" data-id="element-54">
              Politique de Confidentialité
            </button>
            <span className="text-white/10" data-id="element-55">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/40 hover:text-champagne-gold text-xs font-light tracking-wide transition-colors cursor-pointer" data-id="element-56">
              Conditions Générales
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-57">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-58">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[80vh] bg-deep-black border border-burgundy/40 rounded-2xl overflow-hidden shadow-2xl" data-id="element-59">
              {/* Header */}
              <div className="sticky top-0 z-10 flex items-center justify-between p-5 border-b border-white/10 bg-deep-black/95 backdrop-blur-sm" data-id="element-60">
                <h3 className="font-playfair text-xl text-cream" data-id="element-61">
                  {activeModal === 'privacy' ? 'Politique de Confidentialité' : 'Conditions Générales'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-white/10 transition-colors cursor-pointer" data-id="element-62">
                  <X size={18} className="text-white/60" data-id="element-63" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-70px)] text-muted-cream font-light text-sm leading-relaxed space-y-5" data-id="element-64">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-65" /> : <TermsContent data-id="element-66" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-champagne-gold font-playfair text-lg" data-id="element-67">
        Dernière mise à jour : Avril 2026
      </p>

      <div className="space-y-4" data-id="element-68">
        <h4 className="text-cream font-medium text-base" data-id="element-69">
          1. Collecte des Données
        </h4>
        <p data-id="element-70">
          Nous collectons uniquement les informations nécessaires au traitement
          de votre commande : adresse e-mail et informations de paiement. Aucune
          donnée personnelle n'est partagée avec des tiers à des fins
          commerciales.
        </p>
      </div>

      <div className="space-y-4" data-id="element-71">
        <h4 className="text-cream font-medium text-base" data-id="element-72">
          2. Utilisation des Données
        </h4>
        <p data-id="element-73">Vos données sont utilisées exclusivement pour :</p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-74">
          <li data-id="element-75">Livrer votre produit numérique</li>
          <li data-id="element-76">Vous envoyer votre confirmation d'achat</li>
          <li data-id="element-77">Assurer le service après-vente et la garantie</li>
        </ul>
      </div>

      <div className="space-y-4" data-id="element-78">
        <h4 className="text-cream font-medium text-base" data-id="element-79">
          3. Protection des Données
        </h4>
        <p data-id="element-80">
          Toutes les transactions sont sécurisées par un cryptage SSL. Vos
          informations de paiement ne sont jamais stockées sur nos serveurs.
        </p>
      </div>

      <div className="space-y-4" data-id="element-81">
        <h4 className="text-cream font-medium text-base" data-id="element-82">4. Cookies</h4>
        <p data-id="element-83">
          Notre site utilise des cookies essentiels au fonctionnement du service
          et des cookies analytiques pour améliorer votre expérience. Vous
          pouvez les désactiver dans les paramètres de votre navigateur.
        </p>
      </div>

      <div className="space-y-4" data-id="element-84">
        <h4 className="text-cream font-medium text-base" data-id="element-85">5. Vos Droits</h4>
        <p data-id="element-86">
          Conformément au RGPD, vous disposez d'un droit d'accès, de
          rectification et de suppression de vos données personnelles. Vous
          pouvez exercer ces droits à tout moment.
        </p>
      </div>

      <div className="space-y-4" data-id="element-87">
        <h4 className="text-cream font-medium text-base" data-id="element-88">
          6. Confidentialité de l'Achat
        </h4>
        <p data-id="element-89">
          L'achat apparaît de manière discrète et confidentielle sur votre
          relevé bancaire. Aucune mention explicite du produit n'y figure.
        </p>
      </div>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-champagne-gold font-playfair text-lg" data-id="element-90">
        Dernière mise à jour : Avril 2026
      </p>

      <div className="space-y-4" data-id="element-91">
        <h4 className="text-cream font-medium text-base" data-id="element-92">1. Objet</h4>
        <p data-id="element-93">
          Les présentes conditions générales régissent la vente du produit
          numérique « L'Algorithme de l'Amour : L'Effet Obsession » et de ses
          bonus associés.
        </p>
      </div>

      <div className="space-y-4" data-id="element-94">
        <h4 className="text-cream font-medium text-base" data-id="element-95">2. Produit</h4>
        <p data-id="element-96">
          Le produit est un guide numérique au format PDF, livré par
          téléchargement immédiat après validation du paiement. Il comprend
          l'ebook principal et les bonus mentionnés sur la page de vente.
        </p>
      </div>

      <div className="space-y-4" data-id="element-97">
        <h4 className="text-cream font-medium text-base" data-id="element-98">
          3. Prix et Paiement
        </h4>
        <p data-id="element-99">
          Le prix affiché est en dollars américains (USD), toutes taxes
          comprises. Le paiement est sécurisé et traité par notre prestataire de
          paiement certifié.
        </p>
      </div>

      <div className="space-y-4" data-id="element-100">
        <h4 className="text-cream font-medium text-base" data-id="element-101">4. Livraison</h4>
        <p data-id="element-102">
          Le produit est livré instantanément par voie électronique. Un lien de
          téléchargement vous est envoyé immédiatement après le paiement. Le
          produit est lisible sur smartphone, tablette et ordinateur.
        </p>
      </div>

      <div className="space-y-4" data-id="element-103">
        <h4 className="text-cream font-medium text-base" data-id="element-104">
          5. Garantie Satisfaite ou Remboursée
        </h4>
        <p data-id="element-105">
          Vous bénéficiez d'une garantie de remboursement intégral de 30 jours à
          compter de la date d'achat. Aucune justification n'est requise. Le
          remboursement est traité sous 5 jours ouvrés.
        </p>
      </div>

      <div className="space-y-4" data-id="element-106">
        <h4 className="text-cream font-medium text-base" data-id="element-107">
          6. Propriété Intellectuelle
        </h4>
        <p data-id="element-108">
          Le contenu du produit est protégé par le droit d'auteur. Toute
          reproduction, distribution ou revente, partielle ou totale, est
          strictement interdite sans autorisation écrite préalable.
        </p>
      </div>

      <div className="space-y-4" data-id="element-109">
        <h4 className="text-cream font-medium text-base" data-id="element-110">7. Responsabilité</h4>
        <p data-id="element-111">
          Les résultats obtenus dépendent de l'application individuelle des
          conseils fournis. Nous ne garantissons aucun résultat spécifique. Le
          produit est fourni à titre informatif et éducatif.
        </p>
      </div>
    </>;
}